export const getSearchQueryFromUrl = (pageUrl: string) => {
  const urlTokens = pageUrl.split("?");
  const urlSearch = urlTokens.length > 1 ? urlTokens[1] : "";

  return urlSearch!;
};

export const getUrlWithoutSearchQuery = (pageUrl: string) => {
  const urlTokens = pageUrl.split("?");
  return urlTokens[0];
};
